import { useCallback } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import { IUrlOverride } from '~/domain/IUrlOverride';
import { RequestCameraPageUrl, RequestPageUrl } from '~/pages/urls';

export const useRequestUrl = () => {
  const params = useParams();
  const [searchParams] = useSearchParams();

  const requestUrl = useCallback((override?: IUrlOverride) => {
    const context = {
      ...Object.fromEntries(searchParams),
      ...params,
      ...override,
    };
    const url = context.camera
      ? RequestCameraPageUrl.expand(context)
      : RequestPageUrl.expand(context);

    return url;
  }, [params, searchParams]);

  return requestUrl;
}
